import { useContext } from 'react'
import { MeContext } from 'contexts/me'
import { DelayIcon } from 'assets/icons'
import { URL_AUTOGESTION } from 'config'
import RoundedIcon from 'components/RoundedIcon'
import LineBulb from 'assets/images/emojis/light-bulb.png'
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'

const ClientInDebtModal = ({ isOpen, setIsOpen }) => {
  const { me } = useContext(MeContext)

  return (
    <ModalContainer isShown={isOpen} setModalFunction={setIsOpen}>
      <div className='text-center text-black'>
        <h2 className='font-bold leading-5'>
          Tenés un crédito con <br /> cuotas demoradas
        </h2>
        <DelayIcon className='mx-auto my-4' />
        <p className='text-xs leading-4 mb-4'>No pudimos generar tu línea</p>
        <div className='flex gap-2 text-left leading-[14px] mb-4 items-center'>
          <RoundedIcon
            className='h-6 w-6'
            icon={<img className='shrink-0 w-3 h-auto' src={LineBulb} alt='' />}
          />
          <p className='font-medium text-2xs'>
            Habilitá nuevamente tu línea manteniendo todos tus pagos al día.
          </p>
        </div>
      </div>
      <PrimaryButton
        className='mt-8'
        buttonText='Pagar'
        primaryButtonFunction={() =>
          window.open(`${URL_AUTOGESTION}${me.profile.identification_number}`)
        }
      />
    </ModalContainer>
  )
}

export default ClientInDebtModal
